<template>
  <div class="home h-100 d-flex align-items-center text-light justify-content-center">
    <!-- Welcome Slider -->
    <div v-if="welcome" class="h-100 w-100">
      <carousel :perPage="1" :perPageCustom="[[768, 1], [1140, 4]]" class="h-100 d-flex justify-content-center">
        <slide class="d-flex justify-content-center align-items-center" tagName="Welcome">
          <div class="col-10 col-md-6 text-center">
            <Logo id="intro-logo" :size="150"/>
            <h1 class="mb-4">Welcome to <span class="text-primary">Qintro</span></h1>
            <p>Convert your phone into a business card in three simple steps.</p>
          </div>
        </slide>
        <slide class="d-flex justify-content-center align-items-center" tagName="Step 1">
          <div class="col-10 col-md-6 col-lg-9 text-center">
            <h2 class="mb-4 text-primary">Step 1:</h2>
            <p>Enter the details you want on your business card.</p>
          </div>
        </slide>
        <slide class="d-flex justify-content-center align-items-center" tagName="Step 2">
          <div class="col-10 col-md-6 col-lg-9 text-center">
            <h2 class="mb-4 text-primary">Step 2:</h2>
            <p>Select your preferred background colour for your card.</p>
          </div>
        </slide>
        <slide class="d-flex justify-content-center align-items-center" tagName="Step 3">
          <div class="col-10 col-md-6 col-lg-9 text-center">
            <h2 class="my-4 text-primary">Step 3:</h2>
            <p>Click <b class="text-primary">Generate My Card</b></p>
            <p>In a few seconds you will receive a mobile wallpaper with an embedded QR Code in your email</p>

            <router-link to="/create"><button type="button" class="btn btn-outline-success mt-4">Start Now</button></router-link>
          </div>
        </slide>
      </carousel>
    </div>
        
    <!-- Default Welcome Screen -->
    <div v-else class="text-center d-flex flex-column justify-content-between align-items-center h-100 intro-text">
      <h1 class="sr-only">Welcome to Qintro</h1>
      <Logo class="mt-auto" id="intro-logo" :size="250"/>
      <p>Your digital business card, made easier.</p>

      <!-- CTA Buttons -->
      <div class="text-center mt-auto mb-auto">
        <router-link to="/create" class="d-block" id="intro-button">
          <button type="button" class="btn btn-outline-success">Start Now</button>
        </router-link>
        <router-link to="/email" class="d-block">
          <button type="button" class="btn btn-link mt-2"><small>Edit Existing Qintro</small></button>
        </router-link>
      </div>
    </div>

    <!-- Cookie Policy Bar -->
    <div class="cookie-policy position-absolute bg-light d-flex py-2 px-3 text-dark d-flex align-items-center" v-if="cookiePolicy">
      <span>This website uses cookies to ensure you get the best experience on our website.</span>
      <button class="btn btn-primary btn--sm ml-4 flex-shrink-0" @click="cookiePolicy = false">Got it</button>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import Logo from '../components/Logo'

export default {
  name: 'home',
  data() {
    return {
      welcome: false,
      cookiePolicy: false
    }
  },
  components: {
    Logo, Carousel, Slide
  },
  methods: {
    showCookiePolicy: function() {

    },
    getLocalStorage: function() {
      if(localStorage.getItem('welcome') == null || localStorage.getItem('welcome') == '') {
        this.welcome = true;
        localStorage.setItem('welcome', false);
      }
      
      if(sessionStorage.getItem('cookieNotif') == null || sessionStorage.getItem('cookieNotif') == '') {
        setTimeout(() => {
          this.cookiePolicy = true;
        }, 3000);
        sessionStorage.setItem('cookieNotif', false);
      }
    }
  },
  beforeMount() {
    document.body.setAttribute("data-theme", "dark")
    this.getLocalStorage();
  }
}
</script>
<style lang="css">
@media screen and (min-width: 1140px) {
  .home {
    left: calc(-45vw + 50%);
    position: relative;
    width: 90vw;
  }
  .VueCarousel-inner {
    flex-wrap: wrap;
  }
  .VueCarousel-inner > .VueCarousel-slide {
    flex-basis: 33.33%;
  }
  .VueCarousel-inner > .VueCarousel-slide:first-child {
    flex-basis: 100%;
  }
  .VueCarousel-inner > .VueCarousel-slide:first-child {
    margin-bottom: 30px;
  }
}
.cookie-policy {
  bottom: 0;
}
</style>